import { Stack, TableCell, TableRow } from '@mui/material';

import { Typography } from '../Typography/Typography';

export const TableNoData = () => (
  <TableRow>
    <TableCell colSpan={12}>
      <Stack sx={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <svg
          width="96"
          height="86"
          viewBox="0 0 96 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.0276 83.3782C73.5387 83.3782 94.2195 77.0522 94.2195 69.2487C94.2195 61.4452 73.5387 55.1191 48.0276 55.1191C22.5165 55.1191 1.83569 61.4452 1.83569 69.2487C1.83569 77.0522 22.5165 83.3782 48.0276 83.3782Z"
            fill="#D3E5F7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.9346 46.6434L67.3805 29.806C66.6341 28.8513 65.5432 28.2734 64.3945 28.2734H30.9522C29.8041 28.2734 28.7132 28.8513 27.9668 29.806L12.4133 46.6434V57.239H82.9353V46.6434H82.9346Z"
            fill="#8DBBE8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M82.7916 71.1812C82.2878 73.3126 80.5181 74.9012 78.413 74.9012H16.9356C14.8305 74.9012 13.0609 73.3119 12.5577 71.1812C12.4617 70.7751 12.4132 70.3578 12.4133 69.9389V46.6428H29.5232C31.4131 46.6428 32.9364 48.3417 32.9364 50.4044V50.4321C32.9364 52.4941 34.4772 54.159 36.3671 54.159H58.9816C60.8715 54.159 62.4122 52.4788 62.4122 50.4162V50.4078C62.4122 48.3452 63.9355 46.6421 65.8254 46.6421H82.9353V69.9396C82.9353 70.3678 82.8852 70.7836 82.7916 71.1812Z"
            fill="#1976D2"
          />
          <rect
            x="29.8386"
            y="9.65381"
            width="13.0769"
            height="1.1303"
            rx="0.56515"
            transform="rotate(45 29.8386 9.65381)"
            fill="#EDF2F7"
          />
          <rect
            x="47.1689"
            y="19.2368"
            width="13.0769"
            height="1.1303"
            rx="0.56515"
            transform="rotate(-90 47.1689 19.2368)"
            fill="#EDF2F7"
          />
          <rect
            x="56.5015"
            y="18.8994"
            width="13.0769"
            height="1.1303"
            rx="0.56515"
            transform="rotate(-45 56.5015 18.8994)"
            fill="#EDF2F7"
          />
        </svg>
        <Typography>Здесь пока ничего нет</Typography>
      </Stack>
    </TableCell>
  </TableRow>
);
